import { render } from "./SubjectDialogContent.vue?vue&type=template&id=37444e7a&scoped=true"
import script from "./SubjectDialogContent.vue?vue&type=script&lang=js"
export * from "./SubjectDialogContent.vue?vue&type=script&lang=js"

import "./SubjectDialogContent.vue?vue&type=style&index=0&id=37444e7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37444e7a"]])

export default __exports__